export class QAltCanvas {
  constructor() {
    this.fCanvasType = null;
    this.fCanvasElement = null;
    this.fCheckSupportsClip = false;
    //	this.fCanvasWidth = null;
    //	this.fCanvasHeight = null;
  }

  InitAltCanvas(
    canvasType,
    canvasElement,
    checkSupportsClip //, width, height
  ) {
    this.fCanvasType = canvasType;
    this.fCanvasElement = canvasElement;
    this.fCheckSupportsClip = checkSupportsClip;
    //	this.fCanvasWidth = width;
    //	this.fCanvasHeight = height;
  }

  GetCanvasType() {
    return this.fCanvasType;
  }

  GetCanvasElement() {
    return this.fCanvasElement;
  }

  // TORK
  SetShift(deltaX, deltaY) {
    this.fCanvasElement["dx"] = deltaX;
    this.fCanvasElement["dy"] = deltaY;
  }

  // TORK
  SetMasterShift(deltaX, deltaY) {
    this.fCanvasElement["mdx"] = deltaX;
    this.fCanvasElement["mdy"] = deltaY;
  }

  // TORK
  SetScale(scaleFactor) {
    this.fCanvasElement["scale"] = scaleFactor;
  }

  SupportsClip() {
    if (this.fCheckSupportsClip) {
      var ce = this.fCanvasElement;
      var supportsClip = ce.SupportsClip();
      return supportsClip;
    }

    return true;
  }

  PreJustifyText() {
    if (this.fCanvasType == "XML") return this.fCanvasElement.PreJustifyText();
    else return true;
  }
}
